import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  resetSurveyScoreState,
  getSurveyScore,
} from "../../../store/surveyScore/action";
import { resetUserState, getUser } from "../../../store/users/action";
import {
  resetSurveyTemplateState,
  getSurveyTemplate as onGetSurveyTemplates,
  addNewSurveyTemplate as onAddNewSurveyTemplate,
  updateSurveyTemplate as onUpdateSurveyTemplate,
  deleteSurveyTemplate as onDeleteSurveyTemplate,
  getSurveyTemplateLoading,
  getSurveyTemplate,
} from "../../../store/surveyTemplate/action";
import {
  getSurvey as onGetSurveys,
  addNewSurvey as onAddNewSurvey,
  updateSurvey as onUpdateSurvey,
  deleteSurvey as onDeleteSurvey,
  getSurveyLoading,
  resetSurveyState,
} from "../../../store/survey/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Survey = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});
  const [userId, setUserId] = useState();
  const dispatch = useDispatch();

  const {
    surveys,
    isSurveyCreated,
    isSurveySuccess,
    loading,
    error,
    companies,
    companyLoading,
    surveyScores,
    surveyScoreLoading,
    positions,
    positionLoading,
    clients,
    clientLoading,
    users,
    userLoading,
    surveyTemplates
  } = useSelector((state) => ({
    surveys: state.Survey.surveys,
    isSurveyCreated:
      state.Survey.isSurveyCreated,
    isSurveySuccess: state.Survey.isSurveySuccess,
    loading: state.Survey.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Survey.error,
    surveyScores: state.SurveyScore.surveyScores,
    surveyScoreLoading: state.SurveyScore.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    users: state.Users.users,
    userLoading: state.Users.loading,
    surveyTemplates: state.SurveyTemplate.surveyTemplates
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [surveyList, setSurveyList] = useState([]);
  const [survey, setSurvey] = useState([]);
  const [appraisalDetailAddedId, setTemplateDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [surveyDetail, setSurveyDetail] = useState(
    []
  );
  const [companyList, setCompanyList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [surveyScoreList, setSurveyScoreList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [detailList, setDetailList] = useState([])
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const ref = useRef(null);

  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const onClickDelete = (survey) => {
    setSurvey(survey);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (surveyDetail) => {
    setSurveyDetail(surveyDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteSurvey = () => {
    if (survey) {
      dispatch(onDeleteSurvey(survey));
      setDeleteModal(false);
    }
  };

  const handleDeleteSurveyDetail = () => {
    if (surveyDetail) {
      setTemplateDetailAddedId(surveyDetail.templateId);
      // dispatch(onDeleteSurveyDetail(surveyDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setSurvey(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSurveys = surveys;
      if (type !== "all") {
        filteredSurveys = surveys.filter(
          (survey) =>
            survey.svt_status.name === type
        );
      }
      setSurveyList(filteredSurveys);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetSurveys());
      dispatch(resetUserState());
      dispatch(getUser());
      dispatch(resetSurveyTemplateState())
      dispatch(getSurveyTemplate())
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (
        obj.data &&
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role
      ) {
        setCompanyName({
          label: obj?.data?.user.user_company.name,
          value: obj?.data?.user.user_company.id,
        });
        setClientName({
          label: obj?.data?.user.user_client.name,
          value: obj?.data?.user.user_client.id,
        });
        setUserId(obj?.data?.userId)
        setRoles(obj?.data?.user?.user_position?.position_role);
      } else setRoles(null);

      if (obj?.data) setUserType(obj?.data?.userType);
    }
  }, [dispatch, surveys, isSearch]);

  useEffect(() => {
    if (!isEmpty(surveys)) {
      setIsEdit(false);
      setSurveyList(surveys);
      let current = 0;
      if (appraisalDetailAddedId !== 0) {
        surveys.forEach((obj, i) => {
          if (obj.id === appraisalDetailAddedId) current = i;
        });
      }
      setInfo(surveys[current]);
    }
  }, [surveys, appraisalDetailAddedId]);

  // useEffect(() => {
  //   if (isSurveyDetailCreated) {
  //     // dispatch(resetSurveyDetailState());
  //     dispatch(resetSurveyState());
  //     dispatch(onGetSurveys());
  //   }
  // }, [dispatch, isSurveyDetailCreated]);

  // useEffect(() => {
  //   if (companies && !companies.length) {
  //     dispatch(resetCompanyState());
  //     dispatch(getCompany());
  //   }
  // }, [dispatch, companies]);

  // useEffect(() => {
  //   if (userType !== "admin") {
  //     if (companyName) {
  //       dispatch(getPosition({ companyId: companyName.value, status: 2 }));
  //     }
  //   }
  // }, [companyName, userType, dispatch]);

  // function handleCompany(e) {
  //   if (e.length > 2) {
  //     const param = { title: e, status: 2 };
  //     dispatch(getCompany(param));
  //   }
  //   return false;
  // }

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUserList(data);
    }
  }, [users]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD")

      .format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSurvey(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  // const handleGetCompany = (id) => {
  //   dispatch(resetCompanyState());
  //   dispatch(getCompany({ clientId: id }));
  // };

  const handleSurveyClick = useCallback(
    (arg) => {
      const data = arg;
      setSurvey({
        id: data.id,
        percentage: data.percentage,
        description: data.description,
        company: {
          label: data.svt_company.name,
          value: data.svt_company.id,
        },
        client: {
          label: data.svt_client.name,
          value: data.svt_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setSurveyDetail(null);
      setSurvey(null);
      setSurveyScoreList([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleSurveyDetailClick = useCallback(
    (arg) => {
      const data = arg;

      setSurveyDetail({
        id: data.id,
        templateId: data.templateId,
        description: data.description,
        score: data.score,
      });

      setIsEditDetail(true);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 1 ? (
                <button
                  className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}><i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  Approve
                </button>
              ) : (
                ""
              )}
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                }}>
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("deleteSurvey") !==
                      -1
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                }
                onClick={() => {
                  const surveyData = cellProps.row.original;
                  onClickDelete(surveyData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "User",
        accessor: "sv_user.name",
        filterable: true,
      },
      {
        Header: "Grup Usaha",
        accessor: "sv_client.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "sv_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
            case "ACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-info">
                  {cell.value}
                </span>
              );
            case "INACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-danger">
                  {cell.value}
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
          }
        },
      },
    ],
    [userType, userRole]
  );

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: surveyList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {/* <Link
                    to="#"
                    className={"btn-icon btn btn-sm btn-light edit-item-btn"}
                    onClick={() => {
                        handleSurveyDetailClick(cellProps.row.original);
                    }}><i className="ri-edit-2-line fs-15"></i>
                  </Link>
                  <Link
                    to="#"
                    className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    onClick={() => {
                      const productOptionData = cellProps.row.original;
                      onClickDeleteDetail(productOptionData);
                    }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Link> */}
            </div>
          );
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      }, {
        Header: "Score",
        accessor: "score",
        filterable: true,
      },
      {
        Header: "Percentage",
        accessor: "percentage",
        filterable: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [info]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);


  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const handleApproveTemplate = () => {
    if (survey) {
      survey.setApprove = true;
      dispatch(onUpdateSurvey(survey));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      surveyDetail: survey && survey.surveyDetail,
      company: survey && survey.company,
      client: survey && survey.client,
      user: survey && survey.user,
      template: survey && survey.template,
      templateDetail: survey && survey.templateDetail,
      description: survey && survey.description,
      percentage: survey && survey.percentage,
      score: survey && survey.score,
    },
    validationSchema: Yup.object({
      // company: Yup.object().required("Please Enter Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSurveyLoading());
      if (isEdit) {
        const updateSurvey = {
          id: survey ? survey.id : 0,
          survey_detail: values.surveyDetail,
          companyId: values.company.value,
          statusId: 1,
          clientId: values.client.value,
          userId: values.user.value,
        };
        dispatch(onUpdateSurvey(updateSurvey));
        validation.resetForm();
      } else {
        const newSurvey = {
          survey_detail: values.surveyDetail,
          companyId: values.company,
          statusId: 1,
          clientId: values.client,
          userId: values.user.value,
        };
        dispatch(onAddNewSurvey(newSurvey));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      templateId:
        (surveyDetail &&
          surveyDetail.templateId) ||
        (survey && survey.id),
      score: surveyDetail && surveyDetail.score,
      description:
        (surveyDetail &&
          surveyDetail.description) ||
        "",
    },
    validationSchema: Yup.object({
      score: Yup.number().required("Please Enter Score Value").nullable(true),
    }),
    onSubmit: (values) => {
      setTemplateDetailAddedId(values.templateId);
      dispatch(getSurveyLoading());
      if (isEditDetail) {
        const updateSurveyDetail = {
          id: surveyDetail ? surveyDetail.id : 0,
          score: values.score,
          description: values.description,
          templateId: values.templateId,
          statusId: 2,
        };
        dispatch(
          // onUpdateSurveyDetail(updateSurveyDetail)
        );
        validationDetail.resetForm();
      } else {
        const newSurveyDetail = {
          score: values.score,
          description: values.description,
          templateId: values.templateId,
          statusId: 2,
        };
        dispatch(
          // onAddNewSurveyDetail(newSurveyDetail)
        );
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      // dispatch(onDeleteSurveyDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetSurveys(param));
  }

  useEffect(() => {
    if (info && info.sv_detail) {
      setDetailList(info.sv_detail)
    }
  }, [info])

  const handleInput = () => {
    if (surveyTemplates && surveyTemplates[0]) {
      let details = []
      validation.setFieldValue("client", surveyTemplates[0]?.clientId);
      validation.setFieldValue("company", surveyTemplates[0]?.companyId);
      surveyTemplates.forEach((template) => {
        details.push({
          templateId: template.id,
          description: template.description,
          percentage: template.percentage
        })
      })
      surveyTemplates.forEach((template) => {
        template.svt_detail.forEach((detail) => {
          details.forEach((det) => {
            if (template.id === det.templateId && detail.isClick) {
              det.score = detail.score
              det.templateDetailId = detail.id
            }
          })
        })
      })
      validation.setFieldValue("surveyDetail", details)
    }
  }

  document.title = "Survey | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal
        data={
          survey && survey.contract_employee
            ? survey.contract_employee.name
            : ""
        }
        show={approveModal}
        onApproveClick={handleApproveTemplate}
        onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSurvey}
        onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalDetail}
        onDeleteClick={handleDeleteSurveyDetail}
        onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Survey" pageTitle="Sales" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Survey Category Data &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={
                        userType === "admin"
                          ? "btn btn-primary add-btn me-2"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("createSurvey") !== -1
                            ? "btn btn-primary add-btn me-2"
                            : "btn btn-primary add-btn me-2 d-none"
                      }
                      id="create-btn" onClick={() => {
                        setSurvey("");
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className=" ri-star-line me-1 align-bottom fs-14"></i>Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className=" ri-star-line me-1 align-bottom fs-14"></i>  All Survey
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "2" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>  INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-3">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>          Search
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            className={""}
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                className={"" + generateFilterable(column)}
                                {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}</strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Survey" : "Add Survey"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label
                              htmlFor="client-field"
                              className="form-label">
                              User&nbsp;
                              {userLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="user"
                              value={validation.values.user}
                              placeholder="Select User"
                              onChange={(e) => {
                                validation.setFieldValue("user", e);
                              }}
                              options={userList}></Select>
                          </div>
                          {surveyTemplates.map((template, templateIdx) => {
                            return (
                              <div className="mb-3" key={"template-" + templateIdx}>
                                <h6>{template.description}</h6>
                                {template.svt_detail.map((detail, detailIdx) => {
                                  return (
                                    <div className="mb-1" key={"detail-" + detailIdx}>
                                      <div className="form-check">
                                        <input className="form-check-input" type="radio" onClick={() => {
                                          detail.isClick = true
                                          handleInput()
                                        }} />
                                        <label className="form-check-label">
                                          {detail.description}
                                        </label>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>)
                          })}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Add Survey"}
                            </span>
                            {loading && (
                              <Spinner
                                size="sm"
                                className="flex-shrink-0"
                                role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal
                  id="showModalDetail"
                  isOpen={modalDetail}
                  centered
                  size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail
                      ? "Edit Survey Detail"
                      : "Add Survey Detail"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label
                            htmlFor="description-field"
                            className="form-label">
                            Description
                          </Label>
                          <Input
                            name="description"
                            id="description-field"
                            rows="4"
                            className="form-control"
                            placeholder="Isi Keterangan"
                            type="textarea"
                            onChange={validationDetail.handleChange}
                            onBlur={validationDetail.handleBlur}
                            value={validationDetail.values.description} />
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label
                            htmlFor="score-field"
                            className="form-label">
                            Score
                          </Label>
                          <Input
                            name="score"
                            id="score-field"
                            className="form-control"
                            placeholder="Enter Score"
                            type="number"
                            onChange={validationDetail.handleChange}
                            onBlur={validationDetail.handleBlur}
                            value={validationDetail.values.score}
                            invalid={
                              validationDetail.touched.score &&
                                validationDetail.errors.score
                                ? true
                                : false
                            } />
                          {validationDetail.touched.score &&
                            validationDetail.errors.score ? (
                            <FormFeedback type="invalid">
                              {validationDetail.errors.score}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}>
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEditDetail
                                ? "Update"
                                : "Add Survey Detail"}
                            </span>
                            {loading && (
                              <Spinner
                                size="sm"
                                className="flex-shrink-0"
                                role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col xxl={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">
                  {info.sv_user
                    ? info.sv_user.name
                    : " - "}
                </h5>
                {/* <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={
                        userType === "admin"
                          ? "btn btn-success add-btn"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("createSurveyDetail") !== -1
                          ? "btn btn-success add-btn"
                          : "btn btn-success add-btn"
                      }
                      id="create-btn"
                      onClick={(e) => {
                        setSurvey(info);
                        dispatch(resetSurveyScoreState());
                        dispatch(
                          getSurveyScore({
                            companyId: info.svt_company.id,
                          })
                        );
                        setIsEditDetail(false);
                        toggleDetail();
                        e.preventDefault();
                      }}>
                      <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                      Add Detail
                    </button>
                    <button
                      className={
                        userType === "admin"
                          ? "btn btn-soft-danger"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("deleteSurveyDetail") !== -1
                          ? "btn btn-soft-danger"
                          : "btn btn-soft-danger d-none"
                      }
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                    </button>
                  </div> */}
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Search...`}
                              value={searchValueSecond ?? ""} />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>{"<"}</Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>{">"}</Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Survey;
